export const purchaseTimelinesEnum = {
    THIS_WEEK: "This Week",
    THIS_MONTH: "This Month",
    ONE_TO_THREE_MONTHS: "1-3 Months",
    THREE_TO_SIX_MONTHS: "3-6 Months",
    UNDECIDED: "I haven't decided yet."
};
